import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const source = event?.currentTarget
    const form =
      (source && "form" in source && source.form instanceof HTMLFormElement && source.form) ||
      this.element.closest("form")
    form?.requestSubmit()
  }
}
